import { render } from "./stepDati.vue?vue&type=template&id=bf996f94&ts=true"
import script from "./stepDati.vue?vue&type=script&lang=ts"
export * from "./stepDati.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__